import React from 'react';
import Icon from '../../../components/AppIcon';

const DocumentCategoryCard = ({ category, isSelected, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full p-4 rounded-lg border-2 transition-all duration-250 text-right ${
        isSelected
          ? 'border-primary bg-primary/10 shadow-warm'
          : 'border-border bg-card hover:border-primary/50 hover:shadow-warm-sm'
      }`}
      aria-pressed={isSelected}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1">
            {category?.name}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground mb-2">
            {category?.description}
          </p>
          <div className="flex items-center gap-4 text-xs md:text-sm">
            <span className="text-muted-foreground">
              {category?.templateCount} قالب
            </span>
            <span className="text-muted-foreground">
              {category?.usageCount} استخدام
            </span>
          </div>
        </div>
        <div className={`p-2 rounded-lg ${isSelected ? 'bg-primary' : 'bg-muted'}`}>
          <Icon 
            name={category?.icon} 
            size={20} 
            color={isSelected ? '#FFFFFF' : 'var(--color-foreground)'} 
          />
        </div>
      </div>
    </button>
  );
};

export default DocumentCategoryCard;